import Axios from "../redux/setupAxios";
import { microserviceNames } from "../app/utils/constants";


const proxyName = microserviceNames.stakeholderMicroserviceWithoutToken;

export async function getPermissionDocuments(request) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/guide-permission-document/list`, {
        params: request,
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function getTatoPermissionDocuments(request) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/tato-permission-document/list`, {
        params: request,
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function bookmarkPermissionDocument(docId) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/guide-permission-document/bookmark/${docId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}


export async function getPermissionDocumentById(docId) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/guide-permission-document/${docId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function getTatoPermissionDocumentById(docId) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/tato-permission-document/${docId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}


export async function getPublicPermissionDocumentById(docId) {
    return (await Axios.get(`${proxyName}/guide-permission-document/public/${docId}`));
}


export async function createPermissionEmptyDocument() {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/guide-permission-document`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}


export async function createTatoPermissionEmptyDocument() {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/tato-permission-document`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updateBorderStatusDocument(docId, req) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/guide-permission-document/update-border-status/${docId}`, req, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updateTouristBorderStatusDocument(touristId, req) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/attended-guide-tourist/update-border-status/${touristId}`, req, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updateEcologyStatusDocument(docId, req) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/guide-permission-document/update-ecology-status/${docId}`, req, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updateTouristEcologyStatusDocument(touristId, req) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/attended-guide-tourist/update-ecology-status/${touristId}`, req, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updatePermissionDocument(request) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/guide-permission-document/${request._id}`, request, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updateTatoPermissionDocument(request) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/tato-permission-document/${request._id}`, request, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function exportPermissionDocuments(request) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/guide-permission-document/export`, {
        responseType: 'blob',
        params: request,
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function exportTatoPermissionDocuments() {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/tato-permission-document/export`, {
        responseType: 'blob',
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}


export async function getCityList(request) {
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/city`, {
        params: request,
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function getCountryList() {
    let result;
    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    const localData = localStorage.getItem("countries")

    if (localData) {
        const parsedData = JSON.parse(localData)
        result = parsedData;
    } else {
        result = (await Axios.get(`${proxyName}/country`, {
            headers: {
                asanToken: asanToken,
                stakeholderToken: stakeholderToken
            }
        })).data
        localStorage.setItem("countries", JSON.stringify(result))
    }

    return result;
}

export async function createAttendedGuideTourist(request) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.post(`${proxyName}/attended-guide-tourist`, request, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function createAttendedTatoTourist(request) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.post(`${proxyName}/attended-tato-tourist`, request, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function getTouristListByDocId(docId) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/attended-guide-tourist?permissionDocumentId=${docId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function getTatoTouristListByDocId(docId) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.get(`${proxyName}/attended-tato-tourist?permissionDocumentId=${docId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function deleteTouristFromDoc(touristId) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.delete(`${proxyName}/attended-guide-tourist/${touristId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function deleteTatoTouristFromDoc(touristId) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.delete(`${proxyName}/attended-tato-tourist/${touristId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function deleteGuidePermissionDocument(docId) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.delete(`${proxyName}/guide-permission-document/${docId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function deleteTatoPermissionDocument(docId) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.delete(`${proxyName}/tato-permission-document/${docId}`, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updateTouristFromDoc(request) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/attended-guide-tourist/${request._id}`, request, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}

export async function updateTatoTouristFromDoc(request) {

    const asanToken = sessionStorage.getItem("asanLoginToken");
    const stakeholderToken = sessionStorage.getItem("token");

    return (await Axios.put(`${proxyName}/attended-tato-tourist/${request._id}`, request, {
        headers: {
            asanToken: asanToken,
            stakeholderToken: stakeholderToken
        }
    }));
}



